// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 590) return "static/chunks/590-bcb2328410d3fb38509c.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"24":"28c7f209f5e79c1a76b5","155":"6b467400ee7185c7c050"}[chunkId] + ".js";
};